import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  // Map d'ID -> label personnalisé
  private customLabels = signal<Map<string, string>>(new Map());

  /**
   * Définit un label personnalisé pour un segment d'URL (généralement un ID)
   */
  setLabel(id: string, label: string): void {
    this.customLabels.update((map) => {
      const newMap = new Map(map);
      newMap.set(id, label);
      return newMap;
    });
  }

  /**
   * Récupère le label personnalisé pour un segment, ou null si non défini
   */
  getLabel(segment: string): string | null {
    return this.customLabels().get(segment) || null;
  }

  /**
   * Supprime un label personnalisé
   */
  clearLabel(id: string): void {
    this.customLabels.update((map) => {
      const newMap = new Map(map);
      newMap.delete(id);
      return newMap;
    });
  }

  /**
   * Supprime tous les labels personnalisés
   */
  clearAll(): void {
    this.customLabels.set(new Map());
  }
}
